import type { SpecialItem } from "@/types/movie";

export const specials: SpecialItem[] = [
  {
    id: "must-watch-2024",
    title: "2024 必看电影精选",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20collage-style%20banner%20of%20glowing%20film%20frames%20floating%20in%20a%20deep%20navy%20space%20with%20warm%20orange%20light%20rays%2C%20premium%20editorial%20key%20art%20feel&width=1600&height=800&seq=qx-sp-01&orientation=landscape",
    intro:
      "一年的好电影都在这里。我们从今年的新片中甄选出兼具口碑与观赏性的佳作，无论你偏爱科幻、悬疑还是温情故事，都能在这份片单里找到属于自己的那一部。",
    reason: "精选年度高分新片，一站式解决选片难题",
    tags: ["年度片单", "高分推荐", "编辑精选"],
    groups: [
      {
        name: "科幻未来",
        description: "穿越星海与时间的想象力之旅",
        movieIds: ["interstellar-journey", "deep-sea-eye", "time-traveler"],
      },
      {
        name: "悬疑犯罪",
        description: "迷雾重重，真相藏在细节里",
        movieIds: ["changan-night", "dark-night-detective", "last-subway"],
      },
      {
        name: "温情治愈",
        description: "在故事里找回被忽略的温柔",
        movieIds: ["tender-years", "homeward", "cloud-city"],
      },
    ],
  },
  {
    id: "classic-renaissance",
    title: "经典重映：光影的黄金年代",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20cinema%20marquee%20glowing%20at%20night%20with%20warm%20orange%20bulbs%20against%20deep%20navy%20sky%2C%20nostalgic%20premium%20editorial%20banner%20style&width=1600&height=800&seq=qx-sp-02&orientation=landscape",
    intro:
      "有些影像，值得被反复观看。这份专题收录了那些经受住时间考验的经典之作，它们或许年代久远，却依然能在今天叩击人心。",
    reason: "跨越年代的光影记忆，重看依旧动人",
    tags: ["经典", "重映", "影史"],
    groups: [
      {
        name: "时代回响",
        description: "记录一个时代的群像与情感",
        movieIds: ["crimson-dawn", "coastline", "letters-from-mountain"],
      },
      {
        name: "人生况味",
        description: "关于成长、告别与重逢",
        movieIds: ["tender-years", "silent-confession", "wilderness-echo"],
      },
    ],
  },
  {
    id: "suspense-night",
    title: "悬疑之夜：一口气看完的高能片单",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20moody%20banner%20of%20a%20rainy%20night%20city%20alley%20with%20warm%20orange%20streetlight%20and%20deep%20navy%20shadows%2C%20cinematic%20noir%20editorial%20banner%20style&width=1600&height=800&seq=qx-sp-03&orientation=landscape",
    intro:
      "喜欢烧脑与反转的观众有福了。这个专题汇集了一批节奏紧凑、悬念十足的悬疑佳作，适合在深夜准备好零食，一口气刷完。",
    reason: "环环相扣的悬念，专治剧荒与无聊",
    tags: ["悬疑", "烧脑", "反转"],
    groups: [
      {
        name: "罪案追凶",
        description: "真相越靠近，危险也越近",
        movieIds: ["dark-night-detective", "chasing-wind", "changan-night"],
      },
      {
        name: "未知恐惧",
        description: "当常识无法解释一切",
        movieIds: ["last-subway", "deep-sea-eye", "time-traveler"],
      },
    ],
  },
  {
    id: "healing-warmth",
    title: "温暖治愈：给疲惫生活的一点光",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20sunrise%20over%20calm%20seaside%20with%20warm%20orange%20glow%20and%20muted%20navy%20shadows%2C%20gentle%20healing%20editorial%20banner%20style&width=1600&height=800&seq=qx-sp-04&orientation=landscape",
    intro:
      "生活偶尔会让人疲惫，但总有一些故事能温柔地接住你。这份片单里有亲情、友情与和解，适合在一个安静的午后慢慢品味。",
    reason: "温柔而有力量，治愈每一个疲惫的瞬间",
    tags: ["治愈", "温情", "亲情"],
    groups: [
      {
        name: "家的方向",
        description: "无论走多远，家始终在那里",
        movieIds: ["homeward", "coastline", "wilderness-echo"],
      },
      {
        name: "青春与梦",
        description: "关于勇气、成长与不认输",
        movieIds: ["youth-parabola", "cloud-city", "tender-years"],
      },
    ],
  },
];